module.exports = "/_next/static/images/DashboardExplore@2x-a3d002cbf6269e48fd4e3a253208f40b.webp";